import React from 'react';
import styled from 'styled-components';
import { space, border, layout, color, typography } from 'styled-system';

import Box from './Box';
import InputLabel from './InputLabel';
import FormError from './FormError';
import theme, { colors } from '@styles/theme';

const Component = styled('input')(
  {
    paddingLeft: 12,
    paddingTop: 8,
    paddingBottom: 8,
    backgroundColor: colors.grayscale.white,
    ...theme.textStyles.body,
    fontWeight: 300
  },
  props => ({
    appearance: 'none',
    borderRadius: '4px',
    boxSizing: 'border-box',
    color: 'inherit',
    width: '100%',
    '&:focus': {
      outline: 'none'
    },
    '&:disabled': {
      opacity: 1 / 4
    },
    '&::-webkit-input-placeholder': {
      color: props.placeholderTextColor ? props.placeholderTextColor : undefined
    }
  }),
  space,
  border,
  layout,
  color,
  typography
);

export default class TextInput extends React.PureComponent {
  render() {
    const {
      newStyle,
      label,
      labelProps,
      containerProps = {},
      error,
      onEnter,
      inputRef,
      formatValue = value => value,
      formatValueOnChange,
      placeholderTextColor = colors.grayscale.gray,
      textStyle,
      afterOnChange,
      onClick,
      value,
      ...rest
    } = this.props;

    return newStyle ? (
      <Box {...containerProps}>
        {label && <InputLabel {...labelProps}>{label}</InputLabel>}
        <Component
          p={0}
          pt={3}
          bg="transparent"
          type="text"
          ref={inputRef}
          border={'none'}
          placeholderTextColor={placeholderTextColor}
          onKeyUp={e => (e.key === 'Enter' && onEnter ? onEnter(e) : null)}
          {...(textStyle ? theme.textStyles[textStyle] : theme.textStyles.displayMedium)}
          onChange={e => {
            const formattedValue = (formatValueOnChange || formatValue)(e.target.value);
            afterOnChange && afterOnChange(formattedValue);
          }}
          value={formatValue(value)}
          onClick={e => {
            e.stopPropagation();
            onClick && onClick();
          }}
          {...rest}
        />
        <FormError error={error} />
      </Box>
    ) : (
      <>
        <Component
          type="text"
          ref={inputRef}
          onKeyUp={e => (e.key === 'Enter' && onEnter ? onEnter(e) : null)}
          {...(textStyle ? theme.textStyles[textStyle] : {})}
          onClick={e => {
            e && e.stopPropagation();
            onClick && onClick();
          }}
          value={value}
          {...rest}
          border={error ? 'error' : 'divider'}
        />
        <FormError error={error} />
      </>
    );
  }
}
